import React from "react";
import PropTypes from "prop-types";

const MiniAPlus = ({
  children,
  content,
  handleClose = () => {},
  href,
  linkClasses,
  logoSrc,
  shouldRenderCloseBtn = false,
  userSignedIn
}) => {
  const renderCloseBtn = () => {
    if (!shouldRenderCloseBtn) return null;

    return (
      <button
        aria-label="Close"
        className="btn btn-sm btn-borderless a-plus-dialog__close-btn"
        onClick={handleClose}
        type="button"
      >
        <span className="lc-icon lc-icon-xs lc-icon-close" aria-hidden="true" />
      </button>
    );
  };

  const renderContent = () => {
    if (content) {
      return (
        <p
          className="a-plus-dialog__content"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      );
    }

    if (children) {
      return <p className="a-plus-dialog__content">{children}</p>;
    }

    return <p className="a-plus-dialog__content" />;
  };

  return (
    <div className="a-plus-dialog a-plus-dialog--mini">
      {renderCloseBtn()}
      <div className="text-center a-plus-dialog__header">
        <img alt="LitCharts Logo" className="brand" src={logoSrc} />
      </div>
      <div className="text-center a-plus-dialog__body subtitle-1">
        {renderContent()}
        <a
          data-amplitude="advancedSearchFilterAccess"
          data-testid="a-plus-dialog-subscribe-link"
          className={`a-plus-dialog__subscribe btn btn-a-plus btn-md btn--icon-left ${
            linkClasses || ""
          }`}
          href={href}
        >
          <i className="lc-icon lc-icon-sm lc-icon-lock-filled" />
          Get LitCharts A<sup>+</sup>
        </a>
      </div>
      {!userSignedIn && (
        <div className="text-center a-plus-dialog__footer subtitle-2">
          <div className="a-plus-dialog__sign-in">
            or <a href="/sign-in">sign in</a>
          </div>
        </div>
      )}
    </div>
  );
};

MiniAPlus.propTypes = {
  children: PropTypes.node,
  content: PropTypes.string,
  handleClose: PropTypes.func,
  href: PropTypes.string.isRequired,
  linkClasses: PropTypes.string,
  logoSrc: PropTypes.string,
  shouldRenderCloseBtn: PropTypes.bool,
  userSignedIn: PropTypes.bool.isRequired
};

export default MiniAPlus;
